export interface IAgentChatBody {
  question: string;
  option: number;
}

export interface IAgentResponseData {
  question: string;
  sql?: string;
  response?: string;
  message?: string;
  createdAt?: string;
  updatedAt?: string;
  errorMessage?: string;
  flowTypeId?: AGENT_CHAT_FILTER_OPTIONS;
  generatedSql?: string;
  id: number;
  userId?: string;
  score?: AGENT_CHAT_SCORE_OPTIONS;
}

export interface IAgentResponse {
  data: IAgentResponseData;
  status: number;
}

export enum AGENT_CHAT_FILTER_OPTIONS {
  DEFAULT = 1,
  ORDER_COMMENTS = 2,
  SERVICE_COMMENTS = 3
}

export enum AGENT_CHAT_FILTER_OPTIONS_LABELS {
  DEFAULT = 'General',
  ORDER_COMMENTS = 'Comentarios en órdenes',
  SERVICE_COMMENTS = 'Comentarios en SLs'
}

export interface IAgentScorePatchBody {
  score: number;
}

export enum AGENT_CHAT_SCORE_OPTIONS {
  DISLIKE = 0,
  LIKE = 1
}
